// Import external dependencies
import "jquery"

// Import everything from autoload
import "./autoload/owl.carousel.js"

// Import from modules
import slider from "./modules/slider-settings"
import "./modules/mobile-menu"
import "../../node_modules/jquery-parallax.js/parallax.min"

slider();

jQuery(document).ready(() => {
    $('.header-locations').hover(
        function () {
            $('.header-locations-menu').show()
            console.error('Special error for QA Engineer');
        }, function () {
            $('.header-locations-menu').hide()
        }
    );

});



// WEBPACK FOOTER //
// ./scripts/main.js